import React, { useState, useEffect } from "react";
//navbar
import NavbarAdminV from "./NavbarAdminV";
// components
import BatchTable from "./StockComponents/BtachTable";
import Filters from "./StockComponents/Filters";
import { StepForward, StepBack } from "lucide-react";

//hooks
import useFetch from "../../hooks/useFetch";

const StockPage = () => {
  const [queryParams, setQueryParams] = useState("");
  const [filters, setFilters] = useState({
    date: {
      startDate: null,
      endDate: null,
    },
    batchName: null,
    range: null,
    page: 1,
    limit: 10,
  });

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  const handleDateChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      date: {
        ...prevFilters.date,
        [key]: value,
      },
    }));
  };

  const handleResetFilters = () => {
    setFilters({
      date: {
        startDate: null,
        endDate: null,
      },
      batchName: null,
      range: null,
    });
  };

  useEffect(() => {
    const params = new URLSearchParams();
    if (filters.batchName) params.append("name", filters.batchName);
    if (filters.date.startDate)
      params.append("created_from", filters.date.startDate);
    if (filters.date.endDate)
      params.append("created_until", filters.date.endDate);
    if (filters.range) params.append("quantity", filters.range);

    // Add pagination defaults
    params.append("page", 1); // Default page
    params.append("limit", 10); // Default limit

    setQueryParams(params.toString());
  }, [
    filters.date.startDate,
    filters.date.endDate,
    filters.batchName,
    filters.range,
  ]);

  const {
    data: batches,
  } = useFetch(
    `${process.env.REACT_APP_BACKEND_URL}/batch/getAll?${queryParams}`
  );


  return (
    <>
      {/* <NavbarAdminV></NavbarAdminV> */}
      <div className="  dark:bg-gray-900">
        <div className="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-2 2xl:grid-cols-1 mb-4">
          <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
            <div className="w-full sm:w-1/2 p-2">
              <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                Sim Batches
              </span>
            </div>
          </div>
        </div>
        <Filters
          ResetFilters={handleResetFilters}
          filters={filters}
          onFilterChange={handleFilterChange}
          onDateChange={handleDateChange}></Filters>
        <BatchTable batches={batches?.data}></BatchTable>
        <div className="flex  gap-4 items-center justify-between px-4 bg-white rounded-md py-3 mt-3 dark:bg-gray-800 dark:text-white">
          <div className="flex items-center gap-4">
            <button
              disabled={filters.page === 1}
              // onClick={() => handlePageChange(filters.page - 1)}
              className="px-2 py-2 bg-slate-500 text-white rounded disabled:opacity-50 cursor-pointer">
              <StepBack size={12}></StepBack>
            </button>
            <span className="text-gray-700 dark:text-gray-300">
              Page {batches?.pagination?.page} /{" "}
              {batches?.pagination?.totalPages}
            </span>
            <button
              disabled={
                !batches?.data?.length || batches?.data?.length < filters.limit
              }
              // onClick={() => handlePageChange(filters.page + 1)}
              className="px-2 py-2 bg-slate-500 text-white rounded disabled:opacity-50 cursor-pointer">
              <StepForward size={12}></StepForward>
            </button>
          </div>
          <span className="dark:text-white">
            Totale : {batches.pagination?.total}
          </span>
        </div>
      </div>
    </>
  );
};

export default StockPage;
